require('./externalTransferFundInfoView.scss');

// @ vendors
const React = require('react');
const { formatText, getFinalTitle, FormattedText } = require('core/i18n').i18n;

// @ components
const AppDownloadWidget = require('components/appDownloadWidget/appDownloadWidget');
const {
    BrokerInvestmentSpecialist,
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');

// @ constants
const { MYPROFILE_BROKER_URL, MYPROFILE_BROKER_EXPLORE_FUNDS_URL } = require('constants/index');

class ExternalTransferFundInfoView extends React.Component {
    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('brokerTransferFundInfoView-brokerTransferFundInfoView_headerTitle'),
            },
        ];
        return (
            <OKCover size="medium" section="broker" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle('brokerTransferFundInfoView-brokerTransferFundInfoView_headerTitle')}
                >
                    <OKButton
                        inverse={true}
                        modifier="ghost"
                        to={MYPROFILE_BROKER_URL}
                        loading={false}
                    >
                        <FormattedText value="brokerTransferFundInfoView-brokerTransferFundInfoView_headerCTA" format="uppercase" />
                    </OKButton>
                </OKHeaderSubPage>
            </OKCover>
        )
    }

    render() {
        const contentBoxTitle = formatText('externalTransferFundInfo-externalTransferFundInfo_title');
        const phoneNumber = <FormattedText className="external-transfer-fund-info-view__phone" value="brokerInvestmentSpecialist-brokerInvestmentSpecialistPhone"/>;
        const OriginIsin = <FormattedText className="external-transfer-fund-info-view__bold" value="externalTransferFundInfo-externalTransferFundInfo_originFundIsin"/>;
        const transferIsin = <FormattedText className="external-transfer-fund-info-view__bold" value="externalTransferFundInfo-externalTransferFundInfo_transferFundIsin"/>;
        const OriginAccount = <FormattedText className="external-transfer-fund-info-view__bold" value="externalTransferFundInfo-externalTransferFundInfo_originFundAccount"/>;
        const wayText = <FormattedText className="external-transfer-fund-info-view__bold" value="externalTransferFundInfo-externalTransferFundInfo_transferOperationsWay"/>;
        const exploreLink = (
            <OKLink to={MYPROFILE_BROKER_EXPLORE_FUNDS_URL} target="_blank">
                <FormattedText className="external-transfer-fund-info-view__link" value="externalTransferFundInfo-externalTransferFundInfo_exploreLink" />
            </OKLink>);
        return (
            <div className="external-transfer-fund-info-view">
                <div className="container-fluid">
                    <div className="row">
                        {this.buildHeader()}
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative no-outside-gutter">
                            <section className="external-transfer-fund-info-view">
                                <div className="row">
                                    <div className="col-xs-8">
                                        <ContentBox
                                            title={contentBoxTitle}
                                            customClassName="external-transfer-fund-info-view__content-box"
                                            titleSeparator={true}
                                        >
                                            <div className="external-transfer-fund-info-view__content">
                                                <div className="external-transfer-fund-info-view__content">
                                                    <FormattedTextWithComponents
                                                        value={'externalTransferFundInfo-externalTransferFundInfo_contactSpecialists'}
                                                        injectedComponents={[phoneNumber]}
                                                    />
                                                </div>
                                                <ul>
                                                    <li className="external-transfer-fund-info-view__content">
                                                        <FormattedTextWithComponents
                                                            value={'externalTransferFundInfo-externalTransferFundInfo_originFund'}
                                                            injectedComponents={[OriginIsin,OriginAccount]}
                                                        />
                                                    </li>
                                                    <li className="external-transfer-fund-info-view__content">
                                                        <FormattedTextWithComponents
                                                            value={'externalTransferFundInfo-externalTransferFundInfo_transferFundWithLink'}
                                                            injectedComponents={[transferIsin, exploreLink]}
                                                        />
                                                    </li>
                                                </ul>
                                                <div className="external-transfer-fund-info-view__content">
                                                    <FormattedText value="externalTransferFundInfo-externalTransferFundInfo_transferIndication"/>
                                                </div>
                                                <div className="external-transfer-fund-info-view__content">
                                                    <FormattedTextWithComponents
                                                        value={'externalTransferFundInfo-externalTransferFundInfo_transferOperations'}
                                                        injectedComponents={[wayText]}
                                                    />
                                                </div>
                                                <ul className="external-transfer-fund-info-view__content">
                                                    <li><FormattedText value="externalTransferFundInfo-externalTransferFundInfo_new"/></li>
                                                    <li><FormattedText value="externalTransferFundInfo-externalTransferFundInfo_subscriptions"/></li>
                                                    <li><FormattedText value="externalTransferFundInfo-externalTransferFundInfo_internalTransfer"/></li>
                                                    <li><FormattedText value="externalTransferFundInfo-externalTransferFundInfo_refund"/></li>
                                                </ul>
                                                <div className="external-transfer-fund-info-view__content">
                                                    <FormattedText value="externalTransferFundInfo-externalTransferFundInfo_footer"/>
                                                </div>
                                            </div>
                                        </ContentBox>
                                    </div>
                                    <div className="col-xs-4 external-transfer-fund-info-view__sidebar">
                                        <BrokerInvestmentSpecialist />
                                        <AppDownloadWidget />
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

module.exports.constructor = ExternalTransferFundInfoView;
module.exports.ExternalTransferFundInfoView = ExternalTransferFundInfoView;
